module.exports = __webpack_public_path__ + "img/80.ccb62bc8.jpg";